import $ from "jquery"
import * as bootstrap from "bootstrap";

export const controlsHelper = {
  methods: {
    handleDropdownEvents: function (baseName, shouldShowMenu) {
      var menu = document.querySelector("." + baseName + "Menu");
      if (menu) {
        menu.style.display = shouldShowMenu ? "block" : "none";
      }
    },
    clickEvent: function (linkUrl) {
      top.location = linkUrl;
    },
    getFileTypeIcon: function(fileType){
      switch(fileType){
        case "doc":
        case "docx":
          return ["far", "file-word"];
        case "jpg":
          return ["far", "file-image"];
        case "pdf":
          return ["far", "file-pdf"];
        case "ppt":
        case "pptx":  
          return ["far", "file-powerpoint"];
        case "xls":
        case "xlsx":
          return ["far", "file-excel"];     
        default:
          return ["far", "file"];
      }
    }
  }
}